/**
 * Minimal entity context for social-export publish forms.
 * Decouples platform forms from fragment vs composition DTOs.
 */
export type SocialExportPublishSource = {
  id: string;
  stationId: string;
  title: string;
  description: string;
  tags: string[];
};

/**
 * Maps a fragment-like object to {@link SocialExportPublishSource}.
 */
export function fragmentToSocialExportPublishSource(fragment: {
  id: string;
  stationId: string;
  title?: string | null;
  description?: string | null;
  tags?: string[] | null;
}): SocialExportPublishSource {
  return {
    id: fragment.id,
    stationId: fragment.stationId,
    title: fragment.title ?? '',
    description: fragment.description ?? '',
    tags: fragment.tags ?? [],
  };
}

/**
 * Maps a composition detail DTO to {@link SocialExportPublishSource}.
 */
export function compositionToSocialExportPublishSource(composition: {
  id: string;
  stationId?: string | null;
  name: string;
}): SocialExportPublishSource {
  return {
    id: composition.id,
    stationId: composition.stationId ?? '',
    title: composition.name,
    description: '',
    tags: [],
  };
}
